import React, { Component } from 'react';
import _ from 'lodash';
import cogoToast from 'cogo-toast';
import './Invoices.scss';

import PendingCommissions from './PendingCommissions';
import PastInvoices from './PastInvoices';
import CreateInvoice from './CreateInvoice';

import {
  getAffiliateInvoices,
  getPendingCommissions,
  getBrandsWithPendingCommissions,
  sendAffiliateInvoice,
  updateCommission
} from '../../api/brands';

class Invoices extends Component {
  componentDidMount() {
    this.syncData();
  }

  syncData = () => {
    getAffiliateInvoices().then(invoices => this.setState({ invoices }));
    getBrandsWithPendingCommissions().then(({ brands }) => {
      this.setState({ brands });
    });
  };

  state = {
    brands: [],
    isLoadingCommissions: false,
    commissions: [],
    invoices: null,
    account: null,
    user: null,
    selectedBrand: null,
    selectedCommissions: []
  };

  clearSelectedState = () => {
    this.setState({
      commissions: [],
      invoices: null,
      account: null,
      user: null,
      selectedBrand: null,
      selectedCommissions: []
    });
  };

  loadCommissionsForBrand = async Brand_id => {
    try {
      this.setState({ isLoadingCommissions: true });
      const resp = await getPendingCommissions(Brand_id);
      this.setState({ commissions: resp.commissions, account: resp.account, user: resp.user || null });
    } catch (error) {
      console.error(error);
      cogoToast.error('Error loading commissions, please try again.');
    } finally {
      this.setState({ isLoadingCommissions: false });
    }
  };

  sendInvoice = async (commissions, type) => {
    const { selectedBrand } = this.state;
    if (!selectedBrand?.id || !commissions?.length || !type) {
      return cogoToast.error('Please select a brand and at least one commission to invoice.');
    }

    cogoToast.info('Generating Invoice...', { hideAfter: 3 });
    const invoiceData = {
      Brand_id: selectedBrand.id,
      commissionids: _.map(commissions, 'id'),
      type
    };

    sendAffiliateInvoice(invoiceData)
      .then(resp => {
        cogoToast.success(
          `Successfully sent invoice, see it here: https://dashboard.stripe.com${window.__IS_PROD__ ? '' : '/test'}/invoices/${
            resp.invoice?.stripeInvoiceId
          }`,
          {
            hideAfter: 8
          }
        );
        this.syncData();
      })
      .catch(err => cogoToast.error(_.get(err, 'data.error', 'Error Submitting Invoice, see console.')))
      .finally(() => {
        this.setState({ selectedCommissions: [] });
      });
  };

  updateCommission = (commission, updates) => {
    updateCommission(commission, updates).then(resp => {
      this.setState({
        commissions: this.state.commissions.map(c => (c.id === resp.id ? resp : c))
      });
    });
  };

  render() {
    const { selectedCommissions, user, account, brands, brandOnboardedUsers, invoices } = this.state;

    return (
      <div className='invoices-outer-container'>
        {brands?.length > 0 && (
          <PendingCommissions
            account={account}
            user={user}
            brands={brands}
            loadCommissionsForBrand={this.loadCommissionsForBrand}
            commissions={this.state.commissions}
            isLoadingCommissions={this.state.isLoadingCommissions}
            selectedBrand={this.state.selectedBrand}
            setSelectedBrand={brand => this.setState({ selectedBrand: brand, commissions: [] })}
            selectedCommissions={selectedCommissions}
            setSelectedCommissions={selectedCommissions => this.setState({ selectedCommissions })}
            updateCommission={this.updateCommission}
            clearSelectedState={this.clearSelectedState}
          />
        )}
        {!!selectedCommissions.length && (
          <CreateInvoice
            commissions={selectedCommissions}
            selectedBrand={this.state.selectedBrand}
            account={account}
            user={user}
            brandOnboardedUsers={brandOnboardedUsers}
            sendInvoice={this.sendInvoice}
          />
        )}
        {invoices && !!invoices.length && <PastInvoices invoices={invoices} />}
      </div>
    );
  }
}

export default Invoices;
